import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PrivateAxios, publicAxios } from '../api';

const initialState = {
  properties: [],
  status: 'idle',
  error: null,
};

export const fetchProperties = createAsyncThunk('properties/fetchProperties', async () => {
  const response = await PrivateAxios.get('/api/user/construction/Constructiontype');
  return response.data.data.construction_type;
});

const getPropertySlice = createSlice({
  name: 'properties',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProperties.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchProperties.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.properties = action.payload;
      })
      .addCase(fetchProperties.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default getPropertySlice.reducer;